import React from "react";
import "./Frame11332.css";

function Frame11332(props) {
  const { className } = props;

  return (
    <div className={`frame-113 ${className || ""}`}>
      <div className="aquisition valign-text-middle inter-medium-star-dust-18px">Aquisition</div>
    </div>
  );
}

export default Frame11332;
